import {
  Box,
  Card,
  Grid,
  makeStyles,
  Typography,
} from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  titleCourse: {
    margin: theme.spacing(4, 6),
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    borderRadius: '12px',
    maxWidth: 330,
    minWidth: 330,
    minHeight: 524,
    maxHeight: 524,
    background: theme.palette.background.card,
    color: theme.palette.common.white,
    padding: theme.spacing(4, 4),
    [theme.breakpoints.between('lg', 'xl')]: {
      margin: theme.spacing(0, 3, 0, 7),
    },
    [theme.breakpoints.up('xl')]: {
      margin: theme.spacing(0, 7),
    },
  },
  statusCard: {
    maxWidth: '20%',
    textAlign: 'center',
    borderRadius: '8px',
    color: theme.palette.common.black,
  },
  title: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: theme.spacing(2, 0),
  },
  cardAction: {
    display: 'flex',
    justifyContent: 'center',
    color: theme.palette.background.secondary,
  },
  overrides: {
    marginBottom: theme.spacing(-2),
  },
  img: {
    marginRight: theme.spacing(1),
  },
  disableCard: {
    background: theme.palette.background.disabled,
    maxWidth: 330,
    minWidth: 330,
    minHeight: 524,
    maxHeight: 524,
    textAlign: 'center',
    fontFamily: 'Raleway',
    color: theme.palette.common.white,
    zIndex: theme.zIndex.drawer + 1,
  },
  backdrop: {
    zIndex: '0 !important',
  },
}));
function SkeletonCourse() {
  const classes = useStyles();
  return (
    <Grid className={classes.container}>
      <Grid direction="column">
        <Grid container direction="row" xs={12}>
          <Card className={classes.card}>
            <Box>
              <Box>
                <Typography className={classes.statusCard}>
                  <Skeleton variant="rect" width={90} height={20} />
                </Typography>
              </Box>
              <Box className={classes.title}>
                <Box>
                  <Typography className={classes.fontTitle}>
                    <Skeleton variant="rect" width={120} height={20} />
                  </Typography>
                  <br />
                  <Typography className={classes.fontTitle}>
                    <Skeleton variant="rect" width={150} height={20} />
                  </Typography>
                </Box>
                <Skeleton variant="circle" width={75} height={75} />
              </Box>
              <Box>
                <Typography variant="body2" className={classes.font}>
                  <Skeleton variant="rect" width={335} height={30} />
                </Typography>
              </Box>
              <Box className={classes.info}>
                <Box className={classes.infoItems}>
                  <Typography variant="body2" className={classes.font}>
                    <Skeleton variant="rect" width={335} height={30} />
                  </Typography>
                </Box>
                <Box className={classes.infoItems}>
                  <Typography variant="body2" className={classes.font}>
                    <Skeleton variant="rect" width={335} height={20} />
                  </Typography>
                </Box>
              </Box>
              <Box>
                <Skeleton variant="rect" width={335} height={30} />
              </Box>
              <Box className={classes.info}>
                <Box className={classes.infoItems}>
                  <Typography variant="body2" className={classes.font}>
                    <br />
                    <Skeleton variant="rect" width={250} height={30} />
                  </Typography>
                </Box>
                <br />
                <Box className={classes.infoItems}>
                  <Typography variant="body2" className={classes.font}>
                    <Skeleton variant="rect" width={250} height={28} />
                  </Typography>
                </Box>
                <br />
                <Box className={classes.infoItems}>
                  <Typography variant="body2" className={classes.font}>
                    <Skeleton variant="rect" width={250} height={28} />
                  </Typography>
                </Box>
              </Box>
              <br />
              <br />
              <br />
              <Box>
                <Skeleton variant="rect" width={335} height={80} />
              </Box>
            </Box>
          </Card>

        </Grid>
      </Grid>
    </Grid>
  );
}

export default SkeletonCourse;
